import { fetchProjectServiceAccounts } from '@neptune/service-accounts-domain';

export async function fetchServiceAccountNames(projectIdentifier: string): Promise<string[]> {
  const serviceAccounts = await fetchProjectServiceAccounts(projectIdentifier);
  return serviceAccounts.map(({ serviceAccountInfo }) => serviceAccountInfo.displayName);
}
